import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// components
import Menu from '~/shared/components/Menu';
import MenuButton from '~/shared/components/MenuButton';
// constants
import {redoIcon, undoIcon} from '~/constants/InlineSvgs';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export class RedoUndoToolbar extends Component {
  render() {
    const {actions, actives} = this.props;
    const tools = actives.undo || actives.redo;

    const toolButtonClasses = inactive => {
      return classnames('ndx-RedoUndoToolbar-toolButton', 'ndx-label4', {
        'ndx-RedoUndoToolbar-toolButton--inactive': inactive
      });
    };

    return (
      <div className="ndx-RedoUndoToolbar u-clickPassThrough">
        {tools && (
          <Menu className="ndx-RedoUndoToolbar-tools">
            <MenuButton
              key="Undo"
              className={toolButtonClasses(!actives.undo)}
              icon={undoIcon}
              text="Undo"
              onClick={actives.undo ? actions.undo : () => {}}
            />
            <MenuButton
              key="Redo"
              className={toolButtonClasses(!actives.redo)}
              icon={redoIcon}
              text="Redo"
              onClick={actives.redo ? actions.redo : () => {}}
            />
          </Menu>
        )}
      </div>
    );
  }
}

RedoUndoToolbar.displayName = 'RedoUndoToolbar';

const propTypes = {
  actions: PropTypes.shape({
    redo: PropTypes.func.isRequired,
    undo: PropTypes.func.isRequired
  }).isRequired,
  actives: PropTypes.shape({
    redo: PropTypes.bool,
    undo: PropTypes.bool
  })
};

RedoUndoToolbar.propTypes = propTypes;

export default RedoUndoToolbar;
